import { configureEcho } from '@laravel/echo-react';
import { type ReactNode, useLayoutEffect, useMemo, useState } from 'react';
import { getToolbarEchoConfig, type ToolbarEchoParams } from './getToolbarEchoConfig';

type ToolbarEchoGateProps = {
	params: ToolbarEchoParams;
	children: ReactNode;
};

/**
 * Calls `configureEcho` before rendering children so hooks like `useEcho` are valid.
 * Remount when `params` fields used in the memoized config change.
 */
export function ToolbarEchoGate({ params, children }: ToolbarEchoGateProps) {
	const [ready, setReady] = useState(false);

	const config = useMemo(() => getToolbarEchoConfig(params), [params]);

	useLayoutEffect(() => {
		configureEcho(config);
		setReady(true);
	}, [config]);

	if (!ready) return null;

	return children;
}
